import { render, staticRenderFns } from "./BulkCalculationsAssumptions.vue?vue&type=template&id=29480398&scoped=true"
import script from "./BulkCalculationsAssumptions.vue?vue&type=script&lang=js"
export * from "./BulkCalculationsAssumptions.vue?vue&type=script&lang=js"
import style0 from "./BulkCalculationsAssumptions.vue?vue&type=style&index=0&id=29480398&prod&lang=scss&scoped=true"
import style1 from "./BulkCalculationsAssumptions.vue?vue&type=style&index=1&id=29480398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29480398",
  null
  
)

export default component.exports